import React, { useState } from 'react';
import { Dropdown, Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const CalendarFilterDropdown = ({ selectedDate, onDateChange }) => {
  const [showCalendar, setShowCalendar] = useState(false);

  return (
    <Dropdown show={showCalendar} onToggle={() => setShowCalendar(!showCalendar)}>
      <Dropdown.Toggle className="btn-transfer-to" variant="primary" id="dropdownMenuButton">
        Filter by Date
      </Dropdown.Toggle>

      <Dropdown.Menu style={{ padding: "10px" }}>
        <DatePicker
          selected={selectedDate}
          onChange={(date) => {
            onDateChange(date);
            setShowCalendar(false); // close dropdown after selection
          }}
          dateFormat="yyyy-MM-dd"
          className="form-control"
          inline
        />
        <div className="d-flex justify-content-between mt-2">
          <button
            className="btn btn-sm btn-secondary"
            onClick={(e) => {
              e.preventDefault();
              onDateChange(null); // Clear filter
              setShowCalendar(false);
            }}
          >
            Clear
          </button>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CalendarFilterDropdown;
